import React, { useContext } from 'react';
import moment from 'moment';
import {
    Cell,
    DeleteCell,
    EditCell,
    LinkCell
} from '../../../generic/AsTable/Standard';
import { tableCellStyle } from '../CampaignBriefStyles';
import { SystemSettingsContext } from '../../../../contexts/SystemSettingsContext';
import { AttachmentType } from '../../../../constants/Enums';

// ASSP-8023 From CampaignContactsDataRow
//
const cellStyle = {
    ...tableCellStyle,
    justifyContent: 'flex-start',
    paddingLeft: 10
};

const CampaignNotesDataRow = ({
    entity = {},
    index,
    scrollPx,
    onHover,
    isHighlighted,
    rowHeight,
    visibleRows,
    readOnly,
    hideEditable = false,
    onEdit,
    onDelete,
    onLinkClick
}) => {
    const { dateFormat } = useContext(SystemSettingsContext);
    /**
     * mouseEnter event handler for all cells in this row
     * used for row highlighting and dragging
     * @param {Event} event - event
     */
    const onMouseEnter = (event) => {
        typeof onHover === 'function' && onHover(index);
    };

    /**
     * mouseLeave event handler for all cells in this row
     * @param {Event} event - event
     */
    const onMouseLeave = (event) =>
        typeof onHover === 'function' && onHover(-1);

    const handleEditClick = () => {
        onEdit(index);
    };

    const handleDeleteClick = () => {
        onDelete(index);
    };

    const handleLinkClick = () => {
        onLinkClick(index);
    };

    return (
        <>
            <EditCell
                area={`i${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                disabled={hideEditable || readOnly}
                style={{ borderWidth: '0 1px 1px 1px' }}
                onClick={handleEditClick}
            />
            <DeleteCell
                area={`ii${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                disabled={hideEditable || readOnly}
                onClick={handleDeleteClick}
            />
            {/* ASSP-8023 Replaced below
            {entity.attachmentTypeId === AttachmentType.NOTE.id ? (
                <Cell
                    area={`name${index}`}
                    rowHeight={rowHeight}
                    scrollPx={scrollPx}
                    index={index}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    isHighlighted={isHighlighted}
                    visibleRows={visibleRows}
                    style={tableCellStyle}
                >
                    {entity.name}
                </Cell>
            ) : (
                <LinkCell
                    area={`name${index}`}
                    rowHeight={rowHeight}
                    scrollPx={scrollPx}
                    index={index}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    isHighlighted={isHighlighted}
                    visibleRows={visibleRows}
                    style={tableCellStyle}
                    onClick={handleLinkClick}
                >
                    {entity.name}
                </LinkCell>
            )}
            */}
            {/* ASSP-8023 Aligned left and link all items */}
            <LinkCell
                area={`name${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={cellStyle}
                onClick={handleLinkClick}
            >
                {entity.name}
            </LinkCell>
            <Cell
                area={`description${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={cellStyle}
            >
                {entity.description}
            </Cell>
            <Cell
                area={`type${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={cellStyle}
            >
                {entity.shortType ?? entity.type}
            </Cell>
            <Cell
                area={`dateCreated${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={cellStyle}
            >
                {entity.dateCreated
                    ? moment(entity.dateCreated).format(dateFormat)
                    : ''}
            </Cell>
            <Cell
                area={`owner${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={cellStyle}
            >
                {entity.attachmentOwner}
            </Cell>
        </>
    );
};

export default CampaignNotesDataRow;
